const EieAssetInstrument = Object.assign({
  BOND_FULL: { title: 'Bond Full', value: 'bond-full' },
  BOND_PP: { title: 'Bond PP', value: 'bond-pp' },
  BOND_WIB: { title: 'Bond WIB', value: 'bond-wib' },
  BOND_PRIIP: { title: 'Bond PRIIP', value: 'bond-priip' },
  PURCHASE_OF_CLAIMS: { title: 'Purchase of claims', value: 'purchase-of-claims-VermgA2a' },
  SILENT_PART: { title: 'Silent Part', value: 'silentpart-VermgA2-3a' },
  SUBORDINATED_LOAN: { title: 'Subordinated Loan', value: 'subordinated-loan-VermgA2-3a' },
  LOAN_ECSP: { title: 'ECSP Loan', value: 'loan-ecsp' },
});

Object.freeze(EieAssetInstrument);

export default EieAssetInstrument;



// WEBPACK FOOTER //
// ./src/enum/eie/EieAssetInstrument.js